<strong>{{item[viewValueProperty]}}</strong>&nbsp;
<em>({{item[valueProperty]}})</em>
